<div
  class="info-credits movie-detail-section"
  [class.more-information-has-rightOwners]="showRightOwners && rightOwners"
>
  <!---->
  <div class="header-msg title" *ngIf="!titleAsLink" (click)="toggleCollapse()" i18n="@@movie.menu.moreInformation">
    More Information
  </div>
  <a
    class="header-msg title title-link"
    *ngIf="titleAsLink"
    [attr.href]="titleAsLink"
    i18n="@@movie.menu.moreInformation"
    >More Information</a
  >
  <!---->
  <ul class="info-list">
    <!-- credits -->
    <ng-container *ngFor="let credit of crewListing">
      <li *ngIf="credit" [ngClass]="credit.roleClass + '-list'">
        <div class="subtitle" [attr.data-translate]="credit.role">
          {{ crewRoleTranslations[credit.role] }}<span class="semicolon">:</span>
        </div>
        <div class="text">
          <span
            *ngFor="let star of credit.starList"
            class="crew {{ star.customClass }}"
            [pTooltip]="star?.episodestooltip"
            tooltipPosition="top"
          >
            <a [routerLink]="star.urlRedirect ? star.urlRedirect : '/talent/' + star.slug">{{ star.name }}</a>
            <span class="comma">, </span>
          </span>
        </div>
      </li>
    </ng-container>
    <!-- more info -->
    <li class="rating-list" *ngIf="movie.certification">
      <div class="subtitle">
        <span i18n="@@movie.field.rating" i18n-attr="@@movie.field.rating" data-translate="movie.field.rating"
          >Rating</span
        ><span class="semicolon">:</span>
      </div>
      <div class="text" [attr.data-translate]="'movie.field.rating.' + movie.certification">
        {{movieRatingTranslations['movie.field.rating.{{ movie.certification }}'] || movie.certification}}
      </div>
    </li>
    <li class="countries-list" *ngIf="infoParams?.countries !== false && countries && countries.length !== 0">
      <div class="subtitle">
        <span i18n="@@movie.field.country" i18n-attr="@@movie.field.country" data-translate="movie.field.country"
          >Country</span
        >
        <span class="semicolon">:</span>
      </div>
      <div class="text">
        <span class="crew" *ngFor="let country of countries"
          ><a
            [routerLink]="'/movies/all/'"
            [queryParams]="{ country: country.id }"
            [attr.data-translate]="country.trMsg"
            >{{ country.name }}</a
          ><span class="comma">, </span></span
        >
      </div>
    </li>
    <li
      class="languages-list"
      *ngIf="infoParams?.languages !== false && movie.languages && movie.languages.length !== 0"
    >
      <div class="subtitle">
        <span i18n="@@movie.field.language" i18n-attr="@@movie.field.language" data-translate="movie.field.language"
          >Language</span
        >
        <span class="semicolon">:</span>
      </div>
      <div class="text languages">
        <span class="crew" *ngFor="let language of movie.languages">
          <a
            [routerLink]="'/movies/all/'"
            [queryParams]="{ languages: language.slug }"
            [attr.data-translate]="language.trMsg"
            >{{ language.name }}</a
          ><span class="comma">, </span></span
        >
      </div>
    </li>
    <li
      class="release-list"
      *ngIf="
        infoParams?.releaseDate !== false &&
        !movie?.locReleaseDate &&
        (movie.releaseDate || infoParams?.releaseDateEmptyMessage)
      "
    >
      <div class="subtitle">
        <span i18n="@@movie.field.release" data-translate="movie.field.release">Release</span
        ><span class="semicolon">:</span>
      </div>
      <div class="text">{{ releaseDate || infoParams?.releaseDateEmptyMessage }}</div>
    </li>
    <li
      class="release-list"
      *ngIf="infoParams?.locReleaseDate !== false && (movie.locReleaseDate || infoParams?.releaseDateEmptyMessage)"
    >
      <div class="subtitle">
        <span i18n="@@movie.field.release" data-translate="movie.field.release">Release</span
        ><span class="semicolon">:</span>
      </div>
      <div class="text">{{ locReleaseDate || infoParams?.releaseDateEmptyMessage }}</div>
    </li>

    <li class="duration-list" *ngIf="infoParams?.duration !== false && movie.locRuntime">
      <div class="subtitle">
        <span i18n="@@movie.field.duration" i18n-attr="@@movie.field.duration" data-translate="movie.field.duration"
          >Duration</span
        ><span class="semicolon">:</span>
      </div>
      <div class="text">{{ movie.locRuntime }} min</div>
    </li>

    <!-- sales agents -->
    <ng-template [ngTemplateOutlet]="salesAgents"></ng-template>
    <!-- sales agents -->
    <ng-container
      *ngTemplateOutlet="thirdPartyData; context: { $implicit: 'third-party-info-wrapper default' }"
    ></ng-container>
  </ul>

  <!-- Right Owners -->
  <div *ngIf="showRightOwners && rightOwners" class="rightOwners rightOwners-more-info">
    <div class="subtitle">
      <span i18n="@@movie.field.rightOwner" i18n-attr="@@movie.field.rightOwner" data-translate="movie.field.rightOwner"
        >Rights owner</span
      ><span class="semicolon">:</span>
    </div>
    <div class="contractual-partners">
      <img
        *ngFor="let ro of rightOwners"
        [ngSrc]="ro.logoUrl"
        [alt]="ro.name"
        width="200"
        height="50"
        style="height: auto"
      />
    </div>
  </div>

  <ng-container *ngIf="showPortrait && movie.portraitPhotoUrl">
    <div class="movie-pic">
      <img
        [ngSrc]="movie.portraitPhotoUrl || portraitPlaceholder"
        [alt]="movie.trTitle + ' poster image'"
        width="300"
        height="400"
        style="height: auto"
        [modal]="{ src: movie.portraitPhotoUrl, type: 'portrait', movie: movie, imgType: 'poster-img' }"
        addSkeleton
      />
      <ng-container
        *ngTemplateOutlet="thirdPartyData; context: { $implicit: 'third-party-info-wrapper secondary hide' }"
      ></ng-container>
    </div>
  </ng-container>
</div>

<!-- THIRD PARTY INFO -->
<ng-template #thirdPartyData let-class>
  <div [ngClass]="class">
    <ul class="third-party-info">
      <li class="imdb" *ngIf="movie.imdb !== null && movie.imdb !== ''">
        <a [href]="'https://www.imdb.com/title/' + movie.imdb" target="_blank">
          <img
            [ngSrc]="'https://cdnstatic.usheru.com/img/usheru/imdb-transparent.png'"
            width="80"
            height="40"
            style="height: auto"
            alt="IMDB Logo"
          />
          <span i18n="@@movie.info.credits.readMoreOn">Read more on</span><span> IMDb</span>
        </a>
      </li>

      <li class="tmdb" *ngIf="movie.tmdb !== null && movie.tmdb !== ''">
        <a
          [href]="'https://www.themoviedb.org/' + (movie.contentType === 3 ? 'tv' : 'movie') + '/' + movie.tmdb"
          target="_blank"
        >
          <img
            ngSrc="https://cdnstatic.usheru.com/img/usheru/tmdb-black.png"
            width="47"
            height="42"
            style="height: auto"
            alt="TMDB Logo"
          />
          <span i18n="@@movie.info.credits.readMoreOn">Read more on</span><span> TMDB</span>
        </a>
      </li>

      <li class="rottentomato" *ngIf="movie.rottentomato && movie.rottentomato !== ''">
        <a [href]="'https://www.rottentomatoes.com/m/' + movie.rottentomato" target="_blank">
          <img
            ngSrc="https://cdnstatic.usheru.com/img/usheru/rottentomato.png"
            width="152"
            height="44"
            style="height: auto"
            alt="Rotten Tomato Logo"
          />
          <span i18n="@@movie.info.credits.readMoreOn">Read more on</span><span> Rotten Tomato</span>
        </a>
      </li>

      <li class="letterboxd" *ngIf="movie.letterboxd && movie.letterboxd !== ''">
        <a [href]="'https://letterboxd.com/film/' + movie.letterboxd" target="_blank">
          <img
            ngSrc="https://cdnstatic.usheru.com/img/usheru/letterboxd.png"
            width="152"
            height="44"
            alt="Letterboxd Logo"
          />
          <span i18n="@@movie.info.credits.readMoreOn">Read more on</span><span> Letterboxd</span>
        </a>
      </li>

      <li *ngIf="showTPAffinity" class="film-affinity">
        <a [href]="'https://www.filmaffinity.com/es/film457848.html'" target="_blank">
          <img
            [ngSrc]="'https://cdnstatic.usheru.com/img/usheru/filmaffinity.png'"
            width="47"
            height="42"
            alt="FilmAffinity Logo"
          />
        </a>
      </li>
    </ul>
  </div>
</ng-template>

<ng-template #salesAgents>
  <li *ngIf="salesAgentsEnabled && movie.salesAgents?.length > 0" class="movie-sales-agents">
    <div class="subtitle">
      <span i18n="@@movie.field.salesAgents">Sales agent</span><span class="semicolon">:</span>
    </div>
    <div class="sales-agent-images">
      <ng-container *ngFor="let company of movie.salesAgents; index as i">
        <img
          (error)="onSalesAgentLogoError(i)"
          *ngIf="company.logoUrl && !imgWithError(i)"
          [ngSrc]="company.logoUrl"
          [loaderParams]="{ keepHeight: 60 }"
          height="60"
          width="150"
          style="width: auto"
          [alt]="company.name + ' logo'"
        />
        <div *ngIf="!company.logoUrl || imgWithError(i)" class="no-logo-sales-agent">
          {{ company.name }}
        </div>
      </ng-container>
    </div>
  </li>
</ng-template>
